import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ALL_MEDAL_PROPERTIES } from '../types/medalProperties';
import { GameGuideMedalDescription } from './gameGuideMedalDescription';
import { GameGuidePowerPlayerFeatureIndicator } from './gameGuidePowerPlayerFeatureIndicator';
// [string, string, string, string] corresponds to the 4 images defined for "top 25" ranked medals
const RANK_TITLES = [
    '1st Place',
    '2nd - 5th Place',
    '6th - 15th Place',
    '16th - 25th Place'
];
export const GameGuideRankedMedalPage = ({ medalType }) => {
    const { name, description, rankedMedalImageUrls } = ALL_MEDAL_PROPERTIES[medalType];
    return (_jsxs(_Fragment, { children: [_jsx(GameGuidePowerPlayerFeatureIndicator, {}), _jsx("p", {}), description, !!rankedMedalImageUrls &&
                rankedMedalImageUrls.map((medalImageUrl, i) => (_jsx(GameGuideMedalDescription, { medalName: name, title: RANK_TITLES[i], imageUrl: medalImageUrl }, i)))] }));
};
